import { computed, ref } from 'vue'
import useCurrentInstance from '~/utils/useCurrentInstance'

const latestPragmaPayLimitAmount = ref<number | null>(null)

export const MIN_PAYMENT_VALUE = 100
export const MAX_PAYMENT_VALUE = 50000

export default function usePragmaPayUtils() {
  const vm = useCurrentInstance()
  const pragmaPayPartnerId = computed(() => vm.$store?.getters['cms/pragmaPayPartnerId'])
  const isPragmaPayEnabled = computed(() => pragmaPayPartnerId.value !== null)

  const isLimitAmountReached = (amount: number) => {
    if (!isPragmaPayEnabled.value || latestPragmaPayLimitAmount.value === null) {
      return false
    }
    return amount > latestPragmaPayLimitAmount.value
  }

  return {
    pragmaPayPartnerId,
    isPragmaPayEnabled,
    latestPragmaPayLimitAmount,
    isLimitAmountReached,
  }
}
